import api from "./api";
import axios from "./axios";

export function getBearerTokenHeader(token) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  };
}
export const Axios_RefreshToken = async (token, refresh_token) => {
  var header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  };

  var response = undefined;
  await axios
    .post(api.femsRefreshToken, { refresh_token: refresh_token }, header)
    .then((res) => {
      response = res;
    })
    .catch((ex) => {
      console.log("Axios_RefreshToken Error", ex);
    });

  return response;
};

export const Axios_PostRecaptchaVerification = async (token) => {
   const response = await axios.post(`${api.postRepcatchaVerification}`,{token});
  return response
};

export const Axios_Logout = async (token) => {
  var header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  };
  await axios
    .post(api.femsLogout, {}, header)
    .then((res) => {})
    .catch((ex) => {
      console.log("Logout Error", ex);
    });

  return false;
};
export const Axios_AMMFetchTickets = async (token) => {
  var response;

  await axios
    .get(api.femsAmmGetTicketList, getBearerTokenHeader(token))
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      throw new Error(err);
    });
  return response;
};
export const Axios_IRAFetchTickets = async (token) => {
  var response;

  await axios
    .get(api.GetIncidents, getBearerTokenHeader(token))
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      throw new Error(err);
    });
  return response;
};
export const Axios_ValidateToken = async (token) => {
  await axios
    .get(api.femsValidateToken, getBearerTokenHeader(token))
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    })
    .finally(() => {});
};
